import React from 'react'
import { useDispatch } from 'react-redux'
import { loadCompanyRequests as loadCompanyRequestsAction } from '../../slices/company_request_slice'
import { loadCompanies as loadCompaniesAction } from '../../slices/company_slice'
import ConfirmCompany from '../ConfirmCompany'
import EditCompany from '../EditCompany'
import MergeCompany from '../MergeCompany'
import RejectCompany from '../RejectCompany'
import { ListCompany } from './ListCompany'
import SearchForm from './SearchForm'

function Main() {
  const dispatch = useDispatch()

  const handleSearch = (query) => {
    dispatch(loadCompaniesAction(query))
    dispatch(loadCompanyRequestsAction(query))
  }

  return (
    <>
      <div className="row">
        <SearchForm onSearch={handleSearch} />
      </div>
      <div className="row">
        <ListCompany />
      </div>
      <EditCompany />
      <RejectCompany />
      <ConfirmCompany />
      <MergeCompany />
    </>
  )
}

export default Main
